import { Injectable } from '@angular/core';
import { ConfigurationDataService } from '@nimmsta/ng-commons-lib/data-access';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { Configuration } from '../models/configuration';

@Injectable({ providedIn: 'root' })
export class ConfigurationService extends ConfigurationDataService<Configuration> {
  updateOrganizationIds(configuration: Configuration, organizationIds: string[]): Observable<Configuration> {
    return this.http.put<Configuration>(`${this.baseUrl}/configurations/${configuration.id}/organizations`, organizationIds);
  }

  getConfigurationFile(id: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.baseUrl}/configurations/${id}/download`, { responseType: 'blob', observe: 'response' });
  }

  protected override get apiEndpoint(): string {
    return '/configurations';
  }
}
